import Switch from 'rc-switch';
import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    ModalFooter,
    Card,
    FormGroup,
    CardImg,
    Label,
    Input,
    CustomInput,
    ButtonGroup,
    CardBody,
    Col,
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_Custom_Urls } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
export default function SEOSettings({
    pageSettings,
    saveIntegration,
    integration,
    allProperties,
    propertyId
}) {
    const [name, setName] = useState('');
    const [avatarLink, setAvatarLink] = useState('');
    const [isAivaHide, setIsAivaHide] = useState(integration.isaivaHide || false);

    const [galleryVisible, setGalleryVisible] = useState(false);
    const [settings, setSettings] = useState({
        ownUrl: '',
        metaTitle: 'Digital Vouchers & eGift Cards',
        metaDescription: 'Digital Vouchers & eGift Cards',
        isEnabled: false,
        searchEngineIndex: false,
        favicon: ''
    });

    useEffect(() => {
        if (pageSettings.seoSettings !== undefined)
            setSettings(pageSettings.seoSettings);
    }, [propertyId]);

    const handleSave = () => {
        if (pageSettings.seoSettings.ownUrl === '') {
            AxiosAPI({
                method: 'post',
                url: API_Custom_Urls,
                data: {
                    GroupId: getGroupID(),
                    IntegrationId: integration.id,
                    Url: settings.ownUrl.replace(' ','')
                },
            }).then(res => {                
                 if (res.data.status !== undefined && res.data.status === 'Done') {
                    pageSettings.seoSettings = settings;
                    saveIntegration({ PageSettings: pageSettings, isaivaHide: isAivaHide });
                }else{
                    NotificationManager.error(
                        "",
                        "Url is not available",
                        3000,
                        null,
                        null,
                        "error"
                      );
                }
            });
        } else {
            AxiosAPI({
                method: 'put',
                url: API_Custom_Urls,
                data: {
                    GroupId: getGroupID(),
                    IntegrationId: integration.id,
                    Url: settings.ownUrl.replace(' ','')
                },
            }).then(res => {                
                if (res.data.status !== undefined && res.data.status === 'Done') {
                    pageSettings.seoSettings = settings;
                    saveIntegration({ PageSettings: pageSettings, isaivaHide: isAivaHide });
                }
                else{
                    NotificationManager.error(
                        "",
                        "Url is not available",
                        3000,
                        null,
                        null,
                        "error"
                      );
                }
            });
        }

    };
    const handleAivaChange = (e) => {
        setIsAivaHide(e.target.checked);
    }

    const handleSettingsChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    }

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setAvatarLink(image.src);
        setSettings({
            ...settings,
            favicon: image.src,
        });
    };

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleGoToUrl = () => {
        handleSave();
        window.open(process.env.REACT_APP_VOUCHER_URL + "/vhp/" + settings.ownUrl);
    }

    return (
        <Fragment>
            <Card>
                <CardBody name="bodyClick text-center">
                    <div className="col-md-12 text-center my-3">
                        <h4> SEO Settings</h4>
                        <p className="mb-4">
                            Boost your voucher store’s SEO with Meta description
                        </p>
                    </div>
                    <Separator className="mb-2" />
                    <div className='col-md-12 mb-3'>
                        <div className='text-right mb-2'>
                            <Switch
                                //className="custom-switch custom-switch-primary custom-switch-small integrationremove"
                                checked={settings.isEnabled}
                                onChange={(primary) => setSettings({ ...settings, isEnabled: primary })}
                            />
                        </div>
                        <div className="text-center">
                            <CardImg
                                top
                                src={settings.favicon}
                                alt="favicon"
                                className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={togglegallery}
                                >
                                    Browse favicon
                                </Button>
                            </div>
                        </div>
                    </div>
                    <Row>
                        <Col className='col-md-12 mb-3'>
                            <Card>
                                <CardBody>
                                    <h4 style={{ color: 'blue' }}>{settings.metaTitle}</h4>
                                    <p style={{ color: 'green' }}><b>{process.env.REACT_APP_VOUCHER_URL}{"/vhp/"}{settings.ownUrl}</b></p>
                                    <p style={{ color: 'gray' }}> {settings.metaDescription}</p>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col className='col-md-12 mb-3'>
                            <h6><b>Standard URL</b></h6>
                            <span style={{ fontSize: '17px', fontWeight: '500' }}>{process.env.REACT_APP_VOUCHER_URL + "/vhp?gid=" + getGroupID() + "&iid=" + integration.id}</span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className='col-md-12 mb-3'>
                            <div className='d-flex justify-content-left mt-3'>
                                <FormGroup className="w-100">
                                    <Label><b>Setup Your Own Url</b></Label>
                                    <div className='d-flex'>
                                        <span className='display-url'>{"https://vouchers.getaiva.com" + "/vhp/"}</span><Input
                                            type="text"
                                            id="ownUrl"
                                            value={settings.ownUrl}
                                            name="ownUrl"
                                            onChange={handleSettingsChange}
                                        ></Input>
                                    </div>
                                </FormGroup>
                            </div>

                            <div className='d-flex justify-content-left mb-3'>
                                <b className='mr-2 text-center'><span style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" onClick={() => handleGoToUrl()}>Go To URL</span></b>
                            </div>
                            <div className='d-flex justify-content-left my-3'>

                                <FormGroup className="mb-2 w-100">
                                    <Label><b>Title (title tag in search results)</b></Label>
                                    <Input
                                        type="text"
                                        id="metaTitle"
                                        value={settings.metaTitle}
                                        name="metaTitle"
                                        onChange={handleSettingsChange}
                                    ></Input>
                                </FormGroup>
                            </div>

                            <div className='d-flex justify-content-left'>
                                <b className='mt-3 text-center'></b>
                                <FormGroup className="mb-2 w-100">
                                    <Label><b>Meta Description (description in search results)</b></Label>
                                    <Input
                                        type="text"
                                        id="metaDescription"
                                        value={settings.metaDescription}
                                        name="metaDescription"
                                        onChange={handleSettingsChange}
                                    ></Input>
                                </FormGroup>
                            </div>
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col md={6}>
                            <b className='text-start'> Let Search Engine Index the page</b>
                        </Col>
                        <Col md={6} className='text-right'>
                            <Switch
                                checked={settings.searchEngineIndex}
                                onChange={(primary) => setSettings({ ...settings, searchEngineIndex: primary })}
                            />
                        </Col>
                    </Row> */}

                    <div className='d-flex justify-content-center mb-2'>
                        <ButtonGroup className="mb-2 text-center" style={{ marginTop: '40px' }}>
                            <Button color="primary" size="xs" outline onClick={handleSave}>
                                Save
                            </Button>
                        </ButtonGroup>
                    </div>
                </CardBody>
            </Card>
            {ImageGalleryButton()}
        </Fragment>
    );
}

